// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash-es';
// CRUD
import { QueryResultsModel } from '../../_base/crud';

import { ContactLoginHistoryModel } from '../_models/contact-login-history.model';
import { ContactsLoginHistoryState } from '../_reducers/contacts-login-history.reducers';

export const selectContactsLoginHistoryState =
  createFeatureSelector<ContactsLoginHistoryState>('contactsLoginHistory');

export const selectContactsLoginHistoryPageLoading = createSelector(
  selectContactsLoginHistoryState,
  (contactsLoginHistoryState) => contactsLoginHistoryState.listLoading,
);

export const selectContactsLoginHistoryShowInitWaitingMessage = createSelector(
  selectContactsLoginHistoryState,
  (contactsLoginHistoryState) => contactsLoginHistoryState.showInitWaitingMessage,
);

export const selectContactsLoginHistoryPageLastQuery = createSelector(
  selectContactsLoginHistoryState,
  (contactsLoginHistoryState) => contactsLoginHistoryState.lastQuery,
);

export const selectContactsLoginHistoryInStore = createSelector(
  selectContactsLoginHistoryState,
  (contactsLoginHistoryState) => {
    const items: ContactLoginHistoryModel[] = [];
    each(contactsLoginHistoryState.ids, (ele) => {
      const index: any = ele;
      items.push(contactsLoginHistoryState.entities[index]);
    });
    return new QueryResultsModel(items, contactsLoginHistoryState.totalCount);
  },
);
